import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Selection = ({ selectType, type }) => {
  return (
    <ul className="selection">
      <li
        className={`type ${type === "Cash" ? "type-active" : ""}`}
        onClick={selectType}
      >
        Cash
      </li>
      <li
        className={`type ${type === "Spin" ? "type-active" : ""}`}
        onClick={selectType}
      >
        Spin
      </li>
    </ul>
  );
};

const CoachSpin = ({ selectType, type }) => {
  const { t } = useTranslation();
  return (
    <section className="our-coaches">
      <div className="container">
        <h2 className="heading text-center">Nossos Treinadores</h2>
        <Selection selectType={selectType} type={type} />
        <ul className="coching-list">
          <li>
            <div className="card-coach">
              <img
                src={t("team.spin.coach.photo.1")}
                alt=""
                className="w-100 img-coach"
              />
              <h4>
                <p>{t("team.spin.coach.name.1")}</p>
              </h4>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

const CoachCash = ({ selectType, type }) => {
  const { t } = useTranslation();
  return (
    <section className="our-coaches">
      <div className="container">
        <h2 className="heading text-center">Nossos Treinadores</h2>
        <Selection selectType={selectType} type={type} />
        <ul className="coching-list">
          <li>
            <div className="card-coach">
              <img
                src={t("team.cash.coach.photo.1")}
                alt=""
                className="w-100 img-coach"
              />
              <h4>
                <p>{t("team.cash.coach.name.1")}</p>
              </h4>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

const CoachPT = () => {
  const [type, setType] = useState("Cash");
  const selectType = (e) => {
    setType(e.target.innerText);
  };
  if (type === "Spin") {
    return <CoachSpin selectType={selectType} type={type} />;
  }
  if (type === "Cash") {
    return <CoachCash selectType={selectType} type={type} />;
  }
};

export default CoachPT;
